// CSS bundle (Vite extracts this into a stylesheet at build time)
import '../css/main.css';

// Custom element registrations (side-effect imports)
import './ui/FreshnessBadge';
import './ui/Search';
import './ui/ObserverPill';
import './ui/OverlaysMenu';
import './ui/SpaceWeatherPill';
import './ui/ConjunctionHud';
import './ui/ShareButton';
import './ui/SettingsMenu';
import './ui/AboutModal';
import './ui/ZoomButton';
import './ui/StationTooltip';
import './ui/AmateurStationTooltip';
import './ui/TopBar';
import './ui/DetailPanel';
import './ui/Timeline';
import './ui/NoWebGL';
import './globe/Globe';
import './App';

import { registerServiceWorker } from './pwa/register-sw';
registerServiceWorker();

// Theme is dark-only (hardcoded via `data-theme="dark"` in shell.php);
// nothing to do here at startup beyond registering custom elements.
